<rw-modal
  modalId="changeOrganizationFolderModal"
  datapendoid="change-organization-folder-modal"
  datatestid="change-organization-folder-modal"
  [title]="actionTitle"
  [arialabel]="actionTitle"
  [dismissible]="true"
  size="lg"
  #modalRef
>
  <div modal-body>
    <div class="row">
      <div>
        <div class="p-field">
          <p><b>Current Folder Name:</b> {{ originalName }}</p>
          <p><b>New Folder Name: </b> {{ newName }}</p>
        </div>
        <div class="no-margin-well m-b-1rem">
          <p class="black">
            <b>Changing the Organization Folder Name means that:</b>
          </p>
          <ul>
            <li>
              This will update the folder name used on your I: drive in File Manager. We will need to update your
              organization's folder name in a few places, which can take a while.
            </li>
            <li>
              All of your users must be logged out of their cloud-hosted desktop to start the process, and you will not
              be able to use AppHub while the name change is in progress.
            </li>
          </ul>
        </div>
        <p>Please note that this process cannot be stopped once it's started.</p>
      </div>
    </div>
  </div>
  <div modal-footer>
    <app-button id="btnClose" buttonStyle="addUserTeritary" label="CANCEL" (clickActionEmitter)="close()"> </app-button>
    <app-button
      id="btnConfirm"
      buttonStyle="dontCreateUserButton"
      label="CHANGE FOLDER NAME"
      (clickActionEmitter)="confirm()"
    >
    </app-button>
  </div>
</rw-modal>
